import script from "./NotificationContent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationContent.vue?vue&type=script&setup=true&lang=js"

import "./NotificationContent.vue?vue&type=style&index=0&id=773fbaa9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773fbaa9"]])

export default __exports__